import { useCallback, useRef } from 'react';
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
export const useImagePreview = () => {
  const viewerRef = useRef<Viewer>();

  const handlePreview = useCallback(
    (e: React.MouseEvent<HTMLImageElement>) => {
      // https://github.com/fengyuanchen/viewerjs/issues/207#issuecomment-428931186
      viewerRef.current?.destroy();
      viewerRef.current = new Viewer(e.currentTarget, {
        inline: false,
        movable: true,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
        },
        title: false,
        navbar: false,
        keyboard: true,
      }).show(true);
    },
    [viewerRef],
  );
  return {
    handlePreview,
  };
};
